<template>
    <BaseModal :id="modalId" dialog-class="modal-dialog-scrollable modal-lg" content-class="p-3" :static-backdrop="true" :keyboard="false">
        <template #header>
                    <h3 class="mb-0">{{ title }}</h3>
        </template>
                    <div v-html="text"></div>
        <template #footer>
                    <button class="btn btn-primary" data-bs-dismiss="modal" @click="handleClose">{{ $t('close') }}</button>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal.vue'

export default {
    components: {
        BaseModal
    },
    name: 'SystemNotificationModal',
    data: () => ({
        modalId: 'systemNotificationModal',
        id: null,
        title: '',
        text: ''
    }),
    mounted() {
        this.read()
    },
    methods: {
        set(data) {
            const {
                id = null,
                title = '',
                text = ''
            } = data

            this.id = id
            this.title = title
            this.text = text
        },
        show() {
            this.$store.commit('modalShow', { id: this.modalId })
            this.cleanupBackdrops()
            this.read()
        },
        read() {
            this.$emit('readed', { id: this.id })
        },
        clear() {
            this.title = ''
            this.text = ''
        },
        handleClose() {
            this.clear()
            this.$emit('closed', { id: this.id })
        },
        cleanupBackdrops() {
            document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
            document.body.classList.remove('modal-open')
            document.body.style.overflow = ''
            document.body.style.paddingRight = ''
        },
    },
}
</script>
